
export default {
  API_URL: 'https://fandiprod-staging.azurewebsites.net/',
  DisableGoogleAnalytics: true,
  AUTHORIZE_NET_URL: 'https://test.authorize.net/payment/payment',
};
